// services
export * from './services/auth.service';
// validators
export * from './components/registration/confirm-password.validator';
